module.exports = __webpack_public_path__ + "media/images/icons/twotone/trademark-circle-6574a670f94fb1570e436beeb936e99f.svg";